import { useFocusIdx, useEditorContext } from '@bay-email/editor';
import { IBlockData } from '@bay-email/core';
import { get } from 'lodash';

export function useSelectedNode<T extends IBlockData = IBlockData>() {
  const { focusIdx } = useFocusIdx();
  const { formState } = useEditorContext();

  const selectedNode = get(formState.values, focusIdx) as T | null;

  return {
    selectedNode,
  };
}
